export default "__VITE_ASSET__CBWAFzoR__"